import { resource as RpcResource } from "../infra/api/rpc/api";
import { ResourceRepository } from "../repositories/resourceRepository";

export const fetchPresetThumbnails =
  (): Promise<RpcResource.IPresetImageSubcategoryList> => {
    const repo = new ResourceRepository();
    return repo.listPresetImage({
      category: RpcResource.ImageCategory.IMAGE_CATEGORY_STORY_SERIES_THUMBNAIL,
    });
  };
